export default __webpack_public_path__ + "static/media/doctype.06e9ed92.svg";